import { __read } from "tslib";
import React, { useState } from "react";
import { Box, Button, CircularProgress, Container, IconButton, Modal, Typography } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { ChangeEmailHeading, EmailInput, StyledCard } from "./styles";
import { useStyles } from "../../styles";
import { validateEmail } from "../../utils/serviceUtils";
var ChangeStudentEmail = function (_a) {
    var fullName = _a.fullName, changeEmailLoading = _a.changeEmailLoading, userEmail = _a.userEmail, onClose = _a.onClose, handleSubmit = _a.handleSubmit;
    var classes = useStyles();
    var _b = __read(useState(""), 2), newEmail = _b[0], setNewEmail = _b[1];
    var _c = __read(useState(true), 2), isEmailValid = _c[0], setIsEmailValid = _c[1];
    var closeModal = function () {
        if (!changeEmailLoading) {
            onClose();
        }
    };
    var handleEmailChange = function (event) {
        var email = event.target.value;
        var isEmailValid = validateEmail(email);
        setIsEmailValid(isEmailValid);
        setNewEmail(email);
    };
    return (React.createElement(Modal, { className: classes.modal, disableEnforceFocus: true, disableAutoFocus: true, open: true, onClose: onClose },
        React.createElement(Container, { maxWidth: "md" },
            React.createElement(Box, { display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" },
                React.createElement(StyledCard, null,
                    React.createElement(Box, { height: "85%" },
                        React.createElement(Box, { display: "flex", alignItems: "center", justifyContent: "space-between" },
                            React.createElement(Typography, { className: classes.title, variant: "h6" }, "Change Students Email"),
                            React.createElement(IconButton, { onClick: onClose },
                                React.createElement(CloseIcon, { color: "disabled" }))),
                        React.createElement(Box, null,
                            React.createElement(Box, { mt: 3 },
                                React.createElement(ChangeEmailHeading, { variant: "caption" }, "Students Name"),
                                React.createElement(Typography, null, fullName)),
                            React.createElement(Box, { mt: 3 },
                                React.createElement(ChangeEmailHeading, { variant: "caption" }, "Students Current Email"),
                                React.createElement(Typography, null, userEmail)),
                            React.createElement(Box, { mt: 3 },
                                React.createElement(ChangeEmailHeading, { variant: "caption" }, "Students New Email"),
                                React.createElement(EmailInput, { InputProps: { disableUnderline: true }, errorText: (!newEmail && "Required") || (!isEmailValid && "Invalid Email"), onChange: handleEmailChange, value: newEmail, type: "text", placeholder: "Enter New Email" })))),
                    React.createElement(Box, { display: "flex", justifyContent: "flex-end", mt: 3 },
                        React.createElement(Button, { variant: "outlined", className: classes.cancelBtn, onClick: closeModal }, "Cancel"),
                        React.createElement(Button, { variant: "contained", color: "primary", className: classes.save, onClick: function () { return handleSubmit(newEmail); }, disabled: !newEmail || !isEmailValid }, changeEmailLoading ? (React.createElement(CircularProgress, { size: "1rem", color: "inherit", thickness: 2, variant: "indeterminate" })) : (React.createElement(React.Fragment, null, "Change Email")))))))));
};
export default ChangeStudentEmail;
//# sourceMappingURL=index.js.map